import React, { Component } from 'react';
import Home from './Home';

// Renders the Home dashboard. Kept as the routing entry point for the default
// ("/" / home) route. Renders <Home/> directly in every environment — an earlier
// dev-only wrapper <div> here broke the .contentwrapper `position: inherit` 80px
// header offset (its parent became a static div), so the content rode up under the
// page header in `npm start`. Production never had the wrapper.
class HomeRoot extends Component
{
    render ()
    {
        return <Home />;
    }
}

export default HomeRoot;
